/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * FavProductsService is responsible for making account favorite products page api calls and model level calculations
 *
 * @module enervee_utils.account
 */
FavProductsService.$inject = [
    '$q',
    '$log',
    'AccountAuthService',
    'AccountSideNavService',
    'GetFetchService',
    'SwiftypeService',
    'UserApiConsumerService'
];
function FavProductsService(
    $q,
    $log,
    AccountAuthService,
    AccountSideNavService,
    GetFetchService,
    SwiftypeService,
    UserApiConsumerService
) {
    let _favoriteProductsIdList = null;

    AccountAuthService.onEveryAuthChange('reset-favorite-products', function () {
        clearStoredFavoriteProducts();
        fetchFavoriteProductsIdList();
    });

    return {
        fetchFavoriteProducts: fetchFavoriteProducts,
        fetchFavoriteProductsIdList: fetchFavoriteProductsIdList,
        clearStoredFavoriteProducts: clearStoredFavoriteProducts,
    };

    /**
     * Gets user's favorite products. Can be called with force=true to re-fetch,
     * or can be re-fetched by calling `FavProductsService.clearStoredFavoriteProducts();`,
     * then calling this function.
     * 
     * @param {Object} options Options object for SwiftypeService.getResults
     * @param {Boolean} [force=true] Force a refetch of favorite products
     * @return {Promise} Resolves with the users favorite products
     */
    function fetchFavoriteProducts(options, force) {
        return GetFetchService.get(
            'favorite-products',
            () => requestFavoriteProducts(options),
            {force: force}
        );
    }

    /**
     * Utility method for clearing out stored favorite products when they
     * need to be re-fetched (i.e. on a new user login, when a new product is
     * favorited, etc.)
     */
    function clearStoredFavoriteProducts() {
        GetFetchService.clear('favorite-products');
        // Also clear the endpoint where we get favorite product counts from
        GetFetchService.clear('profile-info');
    }

    /**
     * Gets the user's favorite product id list.
     * 
     * @param {Boolean} [force=true]
     * @returns {*}
     */
    function fetchFavoriteProductsIdList(force) {
        if (AccountAuthService.isAuthenticated()) {
            var urlOptions = {
                url: 'api/1.0/favorite-products/',
                requestingService: UserApiConsumerService.request
            };
            return GetFetchService.get('favorite-product-ids', urlOptions, {force: force}).then(function (response) {
                _favoriteProductsIdList = response;
                AccountSideNavService.updateSideNavFavoriteProductCount(_favoriteProductsIdList.length);
                return _favoriteProductsIdList;
            }, function () {
                return $q.reject();
            });
        } else {
            // If the user is not authenticated, resolve to an empty
            // array (no favorites)
            return $q.resolve([]);
        }
    }

    /**
     * Request the user's favorite products
     * 
     * @param {Object} options Options object for SwiftypeService.getResults
     * @return {Promise} Resolves with the users favorite products
     */
    function requestFavoriteProducts(options) {
        return SwiftypeService.getResults(options).then(function (data) {
            var productsByCategoryArr = [];
            angular.forEach(data.records, function(products, categoryCode) {
                if (products.length > 0) {
                    productsByCategoryArr.push({
                        categoryCode: categoryCode,
                        products: products
                    });
                }
            });
            return {
                'results': productsByCategoryArr,
                'info': data.info,
                'resultsUrl': data.resultsUrl,
            };
        }, function (error) {
            $log.error(error);
            return $q.reject({redirectTo: '404'});
        });
    }
}

module.exports = FavProductsService;
